import { SettingsGridView } from '~/components/system/settings';
import { PageContainer } from '~/components/page-container';

export function Settings() {
	return (
		<PageContainer>
			<SettingsGridView />
		</PageContainer>
	);
}
